import axiosInstance from "../lib/axiosInstance";

const AcademicModal = class {
  constructor() {
    this.baseUrl = "/adminapi/adcategory/";
  }

  async list(data = []) {
    return (
      await axiosInstance.get(`/adminapi/getadcategory/`)
    ).data;
  }

  async listbyidAcademicSubCategory(data = []) {
    return (
      await axiosInstance.get(`/adminapi/getadcategory/?parentid=${data}`)
    );
  }

  async listbyAcademicAlldatabyid(data = []) {
    return (
      await axiosInstance.get(`/adminapi/getadcategory/?id=${data}`)
    );
  }
  
  async removeAcademic(data = {}) {
    return await axiosInstance.delete(`${this.baseUrl}?id=${data}`);
  }

  async createAcademic(data = []) {
    return await axiosInstance.post( this.baseUrl, data);
  }

  async Editacademic(data = []) {
    return await axiosInstance.put(this.baseUrl, data);
  }
  
};

export default new AcademicModal();
